import React, { useEffect, useState } from "react";
import Modal from "../components/ui/Modal";
import { getBookings } from "../api/bookingApi";
import { normalizeBookings } from "../utils/adminData";

const AdminBookingsPage = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [viewBookingOpen, setViewBookingOpen] = useState(false);

  useEffect(() => {
    const loadBookings = async () => {
      setLoading(true);
      setErrorMessage("");

      const response = await getBookings();
      const nextBookings = normalizeBookings(response);

      setBookings(nextBookings);
      setLoading(false);

      if (response?.Success === false && nextBookings.length === 0) {
        setErrorMessage(response?.Message || "Unable to load bookings right now.");
      }
    };

    loadBookings();
  }, []);

  const handleViewBooking = (booking) => {
    setSelectedBooking(booking);
    setViewBookingOpen(true);
  };

  return (
    <div className="space-y-4">
      <section className="rounded-md border border-slate-200 bg-white px-4 py-4 sm:px-5">
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">Bookings</h1>
        <p className="mt-1 text-sm text-slate-500">Manage all booking requests.</p>

        {errorMessage ? (
          <div className="mt-4 rounded-md border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
            {errorMessage}
          </div>
        ) : null}
      </section>

      <section className="rounded-md border border-slate-200 bg-white px-4 py-4 sm:px-5">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h2 className="text-base font-semibold text-slate-900">All Bookings</h2>
            <p className="text-sm text-slate-500">{bookings.length} booking records available.</p>
          </div>
        </div>

        {loading ? (
          <div className="mt-4 rounded-md border border-slate-200 bg-slate-50 px-4 py-4 text-sm text-slate-500">Loading bookings...</div>
        ) : bookings.length ? (
          <div className="mt-4 overflow-x-auto rounded-md border border-slate-200">
            <table className="min-w-full text-left text-sm">
              <thead className="bg-slate-50">
                <tr className="text-slate-500">
                  <th className="px-4 py-3 font-medium">Booking ID</th>
                  <th className="px-4 py-3 font-medium">Patient Name</th>
                  <th className="px-4 py-3 font-medium">Mobile</th>
                  <th className="px-4 py-3 font-medium">Consultation Type</th>
                  <th className="px-4 py-3 font-medium">Visit Price</th>
                  <th className="px-4 py-3 font-medium">Booking Date</th>

                </tr>
              </thead>
              <tbody>
                {bookings.map((booking) => (
                  <tr
                    key={booking.id}
                    className="border-t border-slate-200 hover:bg-slate-50"
                  >
                    <td className="px-4 py-3">{booking.id || "-"}</td>

                    <td className="px-4 py-3">{booking.patientName || "-"}</td>

                    <td className="px-4 py-3">{booking.mobile || "-"}</td>

                    <td className="px-4 py-3">
                      {booking.consultantType || "-"}
                    </td>
                    <td className="px-4 py-3">{booking.visitPrice || "-"}</td>
                    <td className="px-4 py-3">
                      {booking.bookingDate || "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="mt-4 rounded-md border border-slate-200 bg-slate-50 px-4 py-4 text-sm text-slate-500">No bookings available yet.</div>
        )}
      </section>

      <Modal isOpen={viewBookingOpen} onClose={() => setViewBookingOpen(false)} title="Booking Details" maxWidth="max-w-xl">
        {selectedBooking ? (
          <div className="space-y-3 text-sm text-slate-700">
            <p><span className="font-semibold text-slate-900">Patient:</span> {selectedBooking.patientName || "-"}</p>
            <p><span className="font-semibold text-slate-900">Mobile:</span> {selectedBooking.mobile || "-"}</p>
            <p><span className="font-semibold text-slate-900">Consultant Type:</span> {selectedBooking.bookingType || selectedBooking.consultationType || "-"}</p>
            <p><span className="font-semibold text-slate-900">visit price:</span> {selectedBooking.visitPrice || "-"}</p>
            <p><span className="font-semibold text-slate-900">Department:</span> {selectedBooking.department || selectedBooking.departmentName || "-"}</p>
            <p><span className="font-semibold text-slate-900">Doctor:</span> {selectedBooking.specialist || selectedBooking.doctor || selectedBooking.doctorName || "-"}</p>
            <p><span className="font-semibold text-slate-900">Date:</span> {selectedBooking.date || selectedBooking.bookingDate || selectedBooking.appointmentDate || "-"}</p>
            <p><span className="font-semibold text-slate-900">Time:</span> {selectedBooking.slot || selectedBooking.time || selectedBooking.visitTiming || "-"}</p>
            <p><span className="font-semibold text-slate-900">Status:</span> {selectedBooking.status || selectedBooking.bookingStatus || "Pending"}</p>
            <p><span className="font-semibold text-slate-900">Notes:</span> {selectedBooking.notes || selectedBooking.message || "-"}</p>
          </div>
        ) : null}
      </Modal>
    </div>
  );
};

export default AdminBookingsPage;
